/* eslint-disable formatjs/no-literal-string-in-jsx */
import styles from "./FeaturesMain.module.scss";
import MiscellaneousCheckmarkCircleFill from "../../common/icons/MiscellaneousCheckmarkCircleFill.tsx";
import MiscellaneousXCircleFill from "../../common/icons/MiscellaneousXCircleFill.tsx";
import {
  featureCookieName,
  FeatureName,
  useRootLoaderFeatures,
} from "../root/rootLoader.ts";
import { setCookie } from "../../common/utils/cookie.ts";
import { useState } from "react";

const descriptions: Record<FeatureName, string> = {
  [FeatureName.TempPlaceholder]: "",
  [FeatureName.ShortNewFeatures]: "New features count as new for only 1 day",
  [FeatureName.ShortDismissibleFeatures]:
    "Dismissible features re-appear after 1 day (for QA testing)",
};

type SomeFeatures = Partial<Record<FeatureName, boolean>>;

export default function FeaturesMain() {
  const allFeatures = Object.values(FeatureName).filter(
    (f) => f !== FeatureName.TempPlaceholder
  );
  // Normally we would want to do a form action and revalidate. However, I do not want
  // to make the feature system feed into app revalidation since we suppress that
  // at the root level and mutation never occurs in such a live context.
  const [myFeatureSettings, setMyFeatureSettings] = useState<SomeFeatures>(
    useRootLoaderFeatures
  );

  const myFeatureNames = Object.keys(myFeatureSettings).filter(
    (key) => myFeatureSettings[key as FeatureName]
  );

  function setFeature(name: FeatureName, value: boolean) {
    const newSettings = { ...myFeatureSettings, [name]: value };
    setCookie(featureCookieName, JSON.stringify(newSettings), 90);
    setMyFeatureSettings(newSettings);
  }

  return (
    <div className={styles.main}>
      <h1>Demo Features</h1>
      {allFeatures.length === 0 ? (
        <div>There are no features to try at the moment.</div>
      ) : (
        <table className="vst-table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Feature Name</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allFeatures.map((name) => (
              <tr key={name}>
                <td>
                  {myFeatureNames.includes(name) ? (
                    <MiscellaneousCheckmarkCircleFill
                      className={styles.checkMark}
                    />
                  ) : (
                    <MiscellaneousXCircleFill className={styles.xMark} />
                  )}
                </td>
                <td>{name}</td>
                <td>{descriptions[name]}</td>
                <td>
                  <button
                    className="vst-link"
                    onClick={() =>
                      setFeature(name, !myFeatureNames.includes(name))
                    }
                  >
                    {myFeatureNames.includes(name) ? "Remove" : "Add"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {/* Regular link to force a reload */}
      <a href="/" className="vst-link">
        Go to Home
      </a>
    </div>
  );
}
